/* eslint-disable import/no-extraneous-dependencies */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { status } from 'constants/general';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'modules/common/components/Button';
import Popup from 'modules/common/components/Popup';
import ItemWithImageSearchField from 'modules/common/components/ItemWithImageSearchField';
import { fetchPharmacyProducts, clearPharmacyProducts } from 'modules/categories/categoriesSlice';
import { getServices } from 'modules/categories/api';
import ServiceRecord from 'modules/modals/AddPricelistServicesModal/ServiceRecord';
import {
  PopupTitleSpan,
  PopupWrapper,
  PopupTitle,
  PopupTitleWrapper,
  Container,
  PopupTitleContainer,
  extendSearchDropDownStyle,
  extendDropDownListItem,
  extendLoaderStyle,
  ButtonsContainer,
  extendBlueButtonStyle,
  ItemsContainer,
  ItemContainer,
  ItemWrapper,
  extendShowMoreButtonStyle,
} from 'modules/modals/AddPricelistServicesModal/AddPricelistServicesModal.style';
import { getProductsList, createQueryParam } from './helper';

const AddPricelistProductsModal = ({ onClose, priceListId, modalStrings }) => {
  const dispatch = useDispatch();
  const pharmacyProducts = useSelector(state => state.categories.pharmacyProducts);

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    pageSize: 10,
    pageNumber: 1,
    searchTerm: '',
  });
  const [isShowMoreBtnShown, toggleShowMoreBtn] = useState(false);

  useEffect(() => {
    if (searchQuery.searchTerm) {
      dispatch(fetchPharmacyProducts(searchQuery));
    }
  }, [searchQuery, dispatch]);

  useEffect(() => {
    if (pharmacyProducts?.data?.length) {
      const productKeys = pharmacyProducts.data.map(product => product.key);

      getServices(
        `PriceListId=${priceListId}&${createQueryParam('ProductKeys', productKeys)}`,
      ).then(response => {
        const productsList = getProductsList(pharmacyProducts.data, response?.data?.data || []);
        toggleShowMoreBtn(searchQuery.pageNumber < (pharmacyProducts.pagesCount || 0));

        if (searchQuery.pageNumber === 1) {
          setSelectedProducts(productsList);
        } else {
          setSelectedProducts(prev => [...prev, ...productsList]);
        }
      });
    } else if (pharmacyProducts.status === status.SUCCESS && searchQuery.pageNumber === 1) {
      setSelectedProducts([]);
      toggleShowMoreBtn(false);
    }
  }, [pharmacyProducts]);

  const searchProducts = keyWord => {
    setSelectedProducts([]);
    setSearchQuery({
      pageSize: 10,
      pageNumber: 1,
      searchTerm: keyWord,
    });
  };

  const onClickShowMore = pageNumber => {
    setSearchQuery({ ...searchQuery, pageNumber });
  };

  const onClickClose = () => {
    setSelectedProducts([]);
    onClose();
    dispatch(clearPharmacyProducts());
  };

  return (
    <Popup showCloseBtn={false}>
      <PopupWrapper>
        <PopupTitleContainer>
          <PopupTitleWrapper>
            <PopupTitle>{modalStrings.title}</PopupTitle>
            <PopupTitleSpan
              onClick={() => {
                onClickClose();
              }}
            />
          </PopupTitleWrapper>
        </PopupTitleContainer>

        <Container>
          <div
            style={{
              height: '85vh',
            }}
          >
            <div
              style={{
                padding: '16px',
                background: '#F1F4F6',
              }}
            >
              <ItemWithImageSearchField
                isRequired
                isDynamic
                isDropDown
                searchable
                key="products-search-list"
                componentName="products-search-list"
                onTypingDelay={500}
                placeHolder={modalStrings.searchBarPlaceHolder}
                fieldValue=""
                onSearch={keyWord => {
                  searchProducts(keyWord);
                }}
                language="en"
                isLoading={pharmacyProducts.status === status.FETCHING}
                extendLoaderStyle={extendLoaderStyle}
                isValid
                extendDropDownStyle={extendSearchDropDownStyle}
                extendDropDownListItem={extendDropDownListItem}
                icon="e905"
              />
            </div>
            <div
              style={{
                height: 'calc(85vh - 145px)',
              }}
            >
              {selectedProducts?.length > 0 && (
                <div>
                  <ItemsContainer>
                    <ItemContainer>
                      <ItemWrapper>Product</ItemWrapper>
                      <ItemWrapper>Price</ItemWrapper>
                    </ItemContainer>
                    {selectedProducts?.map(item => {
                      const { productName, productKey } = item;
                      return (
                        <ServiceRecord
                          key={productKey}
                          serviceKey={productKey}
                          serviceName={productName}
                          servicePrevPrice={item?.prevValue}
                          priceListId={priceListId}
                          servicePrevType={item?.productPrevType}
                          allowEditType
                        />
                      );
                    })}
                    {isShowMoreBtnShown && (
                      <Button
                        onClick={() => {
                          onClickShowMore(searchQuery.pageNumber + 1);
                        }}
                        btnText="Show more"
                        extendButtonStyle={extendShowMoreButtonStyle}
                        key="show-more-products"
                        isLoading={pharmacyProducts.status === status.FETCHING}
                        extendLoaderStyle={extendLoaderStyle}
                      />
                    )}
                  </ItemsContainer>
                </div>
              )}
            </div>
            <ButtonsContainer>
              <Button
                onClick={() => {
                  onClickClose();
                }}
                btnText="Close"
                extendButtonStyle={extendBlueButtonStyle}
                key="dismiss-popup"
              />
            </ButtonsContainer>
          </div>
        </Container>
      </PopupWrapper>
    </Popup>
  );
};

AddPricelistProductsModal.propTypes = {
  onClose: PropTypes.func,
  priceListId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalStrings: PropTypes.shape({
    title: PropTypes.string,
    searchBarPlaceHolder: PropTypes.string,
  }),
};

export default AddPricelistProductsModal;
